module.exports = require("babel-runtime/helpers/asyncToGenerator");


//////////////////
// WEBPACK FOOTER
// external "babel-runtime/helpers/asyncToGenerator"
// module id = 11
// module chunks = 0